import { I18n } from '@/i18n/I18n';
import { cn } from '@/frontend/lib/utils';
import { SheetIdChange } from '@/reports/bundles/inputSheet';

/** One changed id, as a line: `serial_number is now serial`. */
export function idChangeLine(c: SheetIdChange): string {
  if (c.change === 'renamed') return I18n.get('rv2IdRenamed', { path: c.path, to: c.to ?? '' });
  if (c.change === 'kind') return I18n.get('rv2IdKindChanged', { path: c.path, from: c.from ?? '', now: c.now ?? '' });
  if (c.change === 'unit') return I18n.get('rv2IdUnitChanged', { path: c.path, from: c.from || I18n.get('rv2NoUnit'), now: c.now || I18n.get('rv2NoUnit') });
  if (c.change === 'choices') return I18n.get('rv2IdChoicesRemoved', { path: c.path, from: c.from ?? '' });
  if (c.change === 'choicesAdded') return I18n.get('rv2IdChoicesAdded', { path: c.path, from: c.from ?? '' });
  if (c.change === 'multiple') return I18n.get(c.now === 'several' ? 'rv2IdMultipleOn' : 'rv2IdMultipleOff', { path: c.path });
  if (c.change === 'onlyDefaults') return I18n.get(c.now === 'off' ? 'rv2IdOnlyDefaultsOff' : 'rv2IdOnlyDefaultsOn', { path: c.path });
  if (c.change === 'condition') return I18n.get('rv2IdConditionAdded', { path: c.path });
  if (c.change === 'source') return I18n.get('rv2IdSourceChanged', { path: c.path, from: c.from || I18n.get('rv2IdFixedValues'), now: c.now || I18n.get('rv2IdFixedValues') });
  return I18n.get('rv2IdRemoved', { path: c.path, label: c.label });
}

/** Changed ids as a list, the first `shown` of them and a count of the rest. */
export function IdChangeList({ changes, shown, className }: { changes: SheetIdChange[]; shown: number; className?: string }) {
  return (
    <ul className={cn('flex flex-col gap-0.5 font-mono text-xs', className)}>
      {changes.slice(0, shown).map((c) => <li key={`${c.change}:${c.path}`}>{idChangeLine(c)}</li>)}
      {changes.length > shown && <li className="font-sans">{I18n.get('rv2IdChangesMore', { count: String(changes.length - shown) })}</li>}
    </ul>
  );
}
